require('./share.css');
var temp = require('./share.ejs');
var tipsTemp = require('./tips.ejs');
var mainTemp = require('./main.ejs');


var F_Share = function (options) {
    this.el = $(mainTemp());
    //console.log(this.el);
    this.options = options;
    this.init();

};

F_Share.prototype.init = function () {
    var _s = this;
    this.isHide = true;
    this.resolveTemplate();
    this.getWeixinQRCode().then(function(e){
        var _self = _s;
        _self.renderQRcodeUrl(e,_self);
        _self.bindDomEvent();
        _self.renderTo();
    });




};



// 创建并解析模板
F_Share.prototype.resolveTemplate = function () {

    var btnHtml = temp({type : this.options.order , data : this.options.data });

    $(this.el).append(btnHtml);
console.log($(this.el))
};

F_Share.prototype.getWeixinQRCode = function () {

    var _self = this;
    //  var tipsHtml;
    return  $.ajax({
        type: 'GET',
        url: this.options.wxqrcodeURl,
        dataType: 'jsonp',
        data: {url : this.options.data.url}
    })


};

F_Share.prototype.renderQRcodeUrl = function (result,_self) {

    var tipsHtml = tipsTemp({qrcode_url : result.qrcode_url});


    $(_self.el).append(tipsHtml);

};

F_Share.prototype.showDialog = function () {
    if(this.isHide) {

        $(this.el).find('.js_weixin_share_tips').fadeIn();
        this.isHide = false;
    }

};

F_Share.prototype.hideDialog = function () {
    if(!this.isHide) {
        $(this.el).find('.js_weixin_share_tips').fadeOut();
        this.isHide = true;
    }
};


// 绑定dom事件
F_Share.prototype.bindDomEvent = function () {

    var _self = this;

    $(this.el).on('mouseenter mouseout' , ".js_weixin_share" , function (e) {
        if(_self.isHide && e.type == 'mouseenter') {
            _self.showDialog();
        }else {
            _self.hideDialog();
        }
    });




    $(this.el).on("click", '.js_sina_share', function () {

        //新浪微博分享
       var href = '//service.weibo.com/share/share.php?url=' + encodeURIComponent(_self.options.url) + '&title=' + encodeURIComponent(_self.options.data.title) + '&summary=' + encodeURIComponent(_self.options.data.summary) + '&pic=' + encodeURIComponent(_self.options.data.picUrl);
        window.open(href);
    });
    $(this.el).on("click", '.js_qqzone_share', function () {

        //qq空间分享
      var  href = '//sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + encodeURIComponent(_self.options.data.url) + '&title=' + encodeURIComponent(_self.options.data.title) + '&pics=' + encodeURIComponent(_self.options.data.picUrl);
        window.open(href);
    });

    $(this.el).on("click", '.js_qq_share', function () {

        //qq分享
      var  href = '//connect.qq.com/widget/shareqq/index.html?url=' + encodeURIComponent(_self.options.data.url) + '&title=' + encodeURIComponent(_self.options.data.title) + '&pics=' + encodeURIComponent(_self.options.data.picUrl);
        window.open(href);
    });
};

F_Share.prototype.renderTo = function () {
    this.options.targetDom.append($(this.el));
};


module.exports = F_Share;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.share.pc/app/index.js